import { render, staticRenderFns } from "./AvtBlagajne.vue?vue&type=template&id=73851746&"
import script from "./AvtBlagajne.vue?vue&type=script&lang=js&"
export * from "./AvtBlagajne.vue?vue&type=script&lang=js&"
import style0 from "./AvtBlagajne.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AvtBlagajne.vue"
export default component.exports